module.exports = __webpack_public_path__ + "media/images/athletes/442-64d2955c347d30c9fdd7142403ba6e7c.png";